<template>
  <div class="input-big__wrapper">
    <div class="input-big__label mb-6">{{ label }}</div>
    <bimInput
      :value="value"
      @input="v => $emit('input', v)"
      class="input-big"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import bimInput from '@/components/form/bimInput/bimInput'

export default {
  name: 'InputBig',
  components: {
    bimInput
  },
  props: {
    value: [String, Number],
    label: String
  }
}
</script>

<style lang="scss" scoped>

.input-big__wrapper {

  .input-big__label {
    font-size: 1.0667rem;
    font-weight: 600;
    line-height: 1.44;
    letter-spacing: 0.0333rem;
    color: #4d4d4d;
    text-transform: uppercase;
    text-align: center;
  }

  .input-big {
    position: relative;

    ::v-deep {
      &, input {
        width: 100%;
        height: 4.8rem;
        font-size: 1.5rem;
        font-weight: normal;
        line-height: 1.02;
        letter-spacing: 0.0067rem;
        text-align: center;
        border-radius: 0.3333rem;
        padding: 0;
        margin: 0;
      }

      .suggestions__wrp {
        top: 100%;
      }

      .bim-input {
        height: 100%;

        input {
          border: solid 1px #d8d8d8;
          height: 100%;
        }

        &.focus, &.notEmpty {

          input {
            border-color: $primary-color;
          }

          label {
            display: none;
          }
        }
      }

      label {
        font-size: 1.5rem !important;
        font-weight: normal;
        line-height: 1.02;
        letter-spacing: 0.0067rem;
        top: 50%;
        left: 50%;
        width: 95%;
        box-sizing: border-box;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
